/* @flow */

export default {
  label: {
    display: 'none',
  },
};
